import React from "react";

import Icon from "../Icon";

export default class ListeningControl extends React.Component {
  constructor(props) {
    super(props);

    // https://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
    const params = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    this.state = {
      firstPlayEnded: false,
      playing: false,
      playComplete: false,
      showPlayButton: params.auto_play === "off" // show play button and don't auto play if auto play is off
    };
  }

  componentDidMount() {
    $(window).on("keydown.listening-control", (e) => {
      if(this.state.firstPlayEnded && !this.state.playComplete) {
        // space
        if(e.which === 32) {
          e.preventDefault();
          this.playAudio({ speed: e.shiftKey ? 0.65 : 1 });
        }
        // enter
        else if(e.which === 13) {
          e.preventDefault();
          this.setState({ playComplete: true });
        }
      }
    });

    if(!this.state.showPlayButton) {
      this.playAudio();
    }
  }

  componentWillUnmount() {
    $(window).off("keydown.listening-control");
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.playComplete && !prevState.playComplete) {
      this.props.onPlayComplete();
    }
  }

  // hear sentence
  // if auto-show sentence on
  // --> show sentence / play ended
  // else
  // --> should see flip button
  // on flip button click --> play ended

  playAudio({ speed = null } = {}) {
    // // https://developers.google.com/web/updates/2017/09/autoplay-policy-changes
    // const promise = this.audio.play();
    // promise.then(_ => {
    //   // Autoplay started!
    // }).catch(error => {
    //   this.setState({ showPlayButton: true });
    // });
    this.audio = this.props.playAudio({
      onPlay: () => {
        this.setState({
          playing: true,
          showPlayButton: false
        });
      },
      onEnded: () => {
        this.setState({
          firstPlayEnded: true,
          playing: false,
          playComplete: this.state.playComplete || this.props.playCompleteOnFirstPlayEnded
        });
      },
      onError: (e) => {
        // check if error triggered by window.speechSynthesis.cancel call
        if(window.SpeechSynthesisEvent && e instanceof window.SpeechSynthesisEvent && e.elapsedTime > 0) {
          return null;
        }

        if(!this.state.showPlayButton && !this.state.firstPlayEnded) {
          return this.setState({ showPlayButton: true });
        }

        alert('Oh no! There was an error with the audio.\n' + e + ' ' + (e || {}).name + '\nSorry about that. Please try again and let us know if you see this message again.');
        this.props.onError();
        // same state as onEnded, could consolidate
        this.setState({
          firstPlayEnded: true,
          playing: false,
          playComplete: this.state.playComplete || this.props.playCompleteOnFirstPlayEnded
        });
      },
      speed
    });
  }

  componentWillUnmount() {
    if(typeof SpeechSynthesisUtterance !== "undefined" && this.audio instanceof SpeechSynthesisUtterance) {
      window.speechSynthesis.cancel();
    }
    else if(this.audio) {
      this.audio.pause();
    }
  }

  render() {
    const { firstPlayEnded, playComplete, playing, showPlayButton } = this.state;
    return (
      <div>
        {/*
        <div className="listening-control" style={{ opacity: playing ? 0.6 : 1 }} onClick={() => this.playAudio()}>
          <Icon name="volume-up" />
          {showPlayButton ? <div style={{ fontSize: '2rem' }}>Click to play!</div> : null}
        </div>
        */}
        {showPlayButton ? <p style={{ fontSize: '2rem' }}>Click to play!</p> : null}
        {/*firstPlayEnded && !playComplete && */(
          <div className="text-center">
            <div>
              <div style={{ display: "inline-block", marginRight: 5 }}>
                <button aria-label="replay audio" className="btn btn-default btn-lg" id="listening-control-replay-btn" onClick={() => this.playAudio()} style={{ height: 120, width: 120 }}><Icon name="volume-up" style={{ fontSize: "2.5em" }} /></button>
                <small className="text-secondary" style={{ display: "block", marginTop: 3, opacity: playComplete ? 0 : 1 }}>(space)</small>
              </div>
              <div style={{ display: "inline-block", marginLeft: 5 }}>
                <button aria-label="show sentence" className="btn btn-default" id="listening-control-sentence-btn" onClick={() => this.playAudio({ speed: 0.65 })}><span>.5x</span></button>
                <small className="text-secondary" style={{ display: "block", marginTop: 3, opacity: playComplete ? 0 : 1 }}>(shift+space)</small>
              </div>
            </div>
            {firstPlayEnded && !playComplete && (
              <div style={{ marginTop: 10 }}>
                <button className="btn btn-lg btn-success joystix" onClick={() => this.setState({ playComplete: true })}>Continue</button>
                <div style={{ marginTop: 1 }}><small className="text-secondary">(enter)</small></div>
              </div>
            )}
          </div>
        )}
      </div>
    );
  }
}
